import { getCookie, setCookie, unsetCookie } from '../util/cookies';

export interface ISessionStore {
    put: (key: string, value: string) => void;
    get: (key: string) => string | null;
    has: (key: string) => boolean;
    delete: (key: string) => void;
}

export const SessionStore: ISessionStore = (() => {
    const prepareKey = key => `__tm_${key.replace(' ', '')}`;

    const storeSessionValue = (key, value) => {
        if ('sessionStorage' in window) {
            sessionStorage.setItem(prepareKey(key), value);
        } else {
            setCookie(prepareKey(key), value, {
                path: '/',
            });
        }
    };

    const getSessionValue = (key) => {
        if ('sessionStorage' in window) {
            return sessionStorage.getItem(prepareKey(key));
        } else {
            return getCookie(prepareKey(key));
        }
    };

    const hasSessionValue = (key) => {
        return getSessionValue(key) !== null;
    };

    const deleteSessionValue = (key) => {
        if ('sessionStorage' in window) {
            sessionStorage.removeItem(prepareKey(key));
        } else {
            unsetCookie(prepareKey(key));
        }
    };

    return {
        put: storeSessionValue,
        get: getSessionValue,
        has: hasSessionValue,
        delete: deleteSessionValue,
    };
})();
